import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonLoading } from '@ionic/react';
import React, { useState } from 'react';
import { IonGrid, IonRow, IonCol } from '@ionic/react';
import { personCircle } from "ionicons/icons";
import { useHistory, useParams } from "react-router-dom";
import { IonItem, IonLabel, IonInput, IonButton, IonIcon, IonAlert } from '@ionic/react';
import axiosCall from '../data/axios';

import { Capacitor } from '@capacitor/core';

function validateEmail(email: string) {
    const re = /^((?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))$/;
    return re.test(String(email).toLowerCase());
}

const AuthReset: React.FC = () => {
    const history = useHistory();
    const { token } : any  = useParams();

    const [password, setPassword] = useState<string>("");
    const [rePassword, setRePassword] = useState<string>("");
    const [iserror, setIserror] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");

    const spinnerOptions = {
        message: 'Please wait...',
        animated: true,
        cssClass: 'drukre-loading',
        showBackdrop: true
    };

    const [spinnerPresent, spinnerDismiss] = useIonLoading();

    const handleReset = () => {

        if (!password || password.length < 6) {
            setMessage("Please enter a valid password");
            setIserror(true);
            return;
        }

        const regData = {
            "new_password": password,
            "confirm_password": rePassword
        }

        spinnerPresent(spinnerOptions);

        const headers = {
            'Content-Type': 'application/json'
        }

        axiosCall("/auth/user/password-reset/"+token, 'post', regData)
            .then((res: any) => {
                spinnerDismiss();
                history.push("/login");
            })
            .catch((error: any) => {
                setMessage("Unable to reset password. Please try again later.");
                setIserror(true);
                spinnerDismiss();
            });

    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle> </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding ion-text-center">
                {Capacitor.isNativePlatform() && (
                    <div style={{
                        height: 'env(safe-area-inset-top)',
                        backgroundColor: 'rgba(107, 105, 105, 0)',
                        minHeight: '30px' // Fallback for older devices
                    }}></div>
                )}
                <IonGrid>
                    <IonRow>
                            <IonCol size-sm="4" offset-sm="4">
                                <IonRow>
                                    <IonCol>
                                        <IonLabel color="danger">{message}</IonLabel>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonIcon
                                            color="drukre"
                                            style={{ fontSize: "70px" }}
                                            icon={personCircle}
                                        />
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonInput type="password" label="New Password" value={password} onIonInput={(e) => setPassword(e.detail.value!)} >
                                            </IonInput>
                                        </IonItem>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonInput type="password" label="Re Enter New Password" value={rePassword} onIonInput={(e) => setRePassword(e.detail.value!)} >
                                            </IonInput>
                                        </IonItem>
                                        {rePassword != password && <p style={{ fontSize: "small", color: "red", textAlign: "center" }}>Passwords did not match!</p>}
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <p style={{ fontSize: "small" }}>
                                            By clicking Reset you agree to our <a href="#">Policy</a>
                                        </p>
                                        <IonButton color="drukre" expand="block" onClick={handleReset}>Reset</IonButton>
                                        <p style={{ fontSize: "medium" }}>
                                            Already have an account? <a href='/login'>Sign In!</a>
                                        </p>

                                    </IonCol>
                                </IonRow>
                            </IonCol>
                            
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default AuthReset;